import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  message,
  InputNumber,
  Upload,
  Collapse,
  Checkbox,
  Modal,
} from "antd";
import axiosInstance from "../api/axiosIntance";
import { UploadOutlined } from "@ant-design/icons";
const { Option } = Select;
const { Panel } = Collapse;
const SignupForm = ({ switchToLogin }) => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formValues, setFormValues] = useState({
    business: "",
    businessAddress: "",
    ownerName: "",
    email: "",
    password: "",
    confirmPassword: "",
    businessType: "",
    state: "",
    city: "",
  });
  const showModal = (e) => {
    e.preventDefault(); // Prevent the default anchor behavior
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const onFinish = (values) => {
    console.log(values);
    axiosInstance.post('/signup').then((res)=>{
      console.log(res);
    })
   
    
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Form Submission Failed:", errorInfo);

    // Check if the error is related to the "terms" field
    const termsError = errorInfo.errorFields.find(
      (field) => field.name[0] === "terms"
    );

    if (termsError) {
      message.error("You must agree to the terms and conditions!");
    }
  };
  const handleInputChange = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  };
  const uploadProps = {
    beforeUpload: () => false, // Prevent auto-upload; handle upload in the backend if needed
  };
  return (
    <div style={{ width: "100%" }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ width: "100%" }}
        onFinishFailed={onFinishFailed}
      >
        <h2>Sign Up</h2>
        <Form.Item
          name="businessType"
          label="Vendor Type"
          rules={[{ required: true, message: "Business Type is required" }]}
        >
          <Select>
            <Option value="Investigation Labs">Investigation Labs</Option>
            <Option value="Medicine Store">Medicine Store</Option>
            <Option value="Diagnostic Imaging Center">
              Diagnostic Imaging Center
            </Option>
            <Option value="Blood Bank">Blood Bank</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="businessName"
          label="Business name"
          rules={[
            {
              required: true,
              type: "text",
              message: "Business is required",
            },
          ]}
        >
          <Input placeholder="Business name" />
        </Form.Item>
        <Form.Item
          name="businessOwnerName"
          label="Business Owner name"
          rules={[
            {
              required: true,
              type: "text",
              message: "Business Owner name is required",
            },
          ]}
        >
          <Input placeholder="Business Owner name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email Address"
          rules={[
            {
              required: true,
              type: "email",
              message: "Valid email is required",
            },
          ]}
        >
          <Input placeholder="Email Address" />
        </Form.Item>
        <Form.Item
          name="number"
          label="Phone Number"
          rules={[
            {
              required: true,
              message: "Phone number is required",
            },
            {
              pattern: /^[0-9]{10}$/, // Adjust to match the desired phone number format
              message: "Please enter a valid 10-digit phone number",
            },
          ]}
        >
          <InputNumber
            placeholder="Phone number"
            style={{ width: "100%" }} // Ensures the input spans the full width
            controls={false} // Removes up/down arrows for a cleaner look
          />
        </Form.Item>
        {/* <Form.Item
          name="ownerName"
          label="Owner Name"
          rules={[{ required: true, message: "Owner Name is required" }]}
        >
          <Input placeholder="Owner Name" />
        </Form.Item> */}

        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: "Password is required" }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          rules={[{ required: true, message: "Confirm Password is required" }]}
        >
          <Input.Password placeholder="Confirm Password" />
        </Form.Item>
        <Form.Item
          name="businessAddress"
          label="Business Address"
          rules={[{ required: true, message: "Business Address is required" }]}
        >
          <Input placeholder="Business Address" />
        </Form.Item>

        <Form.Item
          name="state"
          label="State"
          rules={[{ required: true, message: "State is required" }]}
        >
          <Select onChange={(value) => handleInputChange("state", value)}>
            <Option value="Andaman and Nicobar Islands">
              Andaman and Nicobar Islands
            </Option>
            <Option value="Andhra Pradesh">Andhra Pradesh</Option>
            <Option value="Arunachal Pradesh">Arunachal Pradesh</Option>
            <Option value="Assam">Assam</Option>
            <Option value="Bihar">Bihar</Option>
            <Option value="Chandigarh">Chandigarh</Option>
            <Option value="Chhattisgarh">Chhattisgarh</Option>
            <Option value="Dadra and Nagar Haveli">
              Dadra and Nagar Haveli
            </Option>
            <Option value="Daman and Diu">Daman and Diu</Option>
            <Option value="Delhi">Delhi</Option>
            <Option value="Goa">Goa</Option>
            <Option value="Gujarat">Gujarat</Option>
            <Option value="Haryana">Haryana</Option>
            <Option value="Himachal Pradesh">Himachal Pradesh</Option>
            <Option value="Jammu and Kashmir">Jammu and Kashmir</Option>
            <Option value="Jharkhand">Jharkhand</Option>
            <Option value="Karnataka">Karnataka</Option>
            <Option value="Kerala">Kerala</Option>
            <Option value="Lakshadweep">Lakshadweep</Option>
            <Option value="Madhya Pradesh">Madhya Pradesh</Option>
            <Option value="Maharashtra">Maharashtra</Option>
            <Option value="Manipur">Manipur</Option>
            <Option value="Meghalaya">Meghalaya</Option>
            <Option value="Mizoram">Mizoram</Option>
            <Option value="Nagaland">Nagaland</Option>
            <Option value="Orissa">Orissa</Option>
            <Option value="Puducherry">Puducherry</Option>
            <Option value="Punjab">Punjab</Option>
            <Option value="Rajasthan">Rajasthan</Option>
            <Option value="Sikkim">Sikkim</Option>
            <Option value="Tamil Nadu">Tamil Nadu</Option>
            <Option value="Telangana">Telangana</Option>
            <Option value="Tripura">Tripura</Option>
            <Option value="Uttar Pradesh">Uttar Pradesh</Option>
            <Option value="Uttarakhand">Uttarakhand</Option>
            <Option value="West Bengal">West Bengal</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="city"
          label="City Name"
          rules={[{ required: true, message: "City Name is required" }]}
        >
          <Input placeholder="City Name" />
        </Form.Item>
        <Form.Item label="Document Upload">
          <Collapse>
            <Panel header="Click to expand for document upload" key="1">
              {/* Aadhar Card Upload */}
              <Form.Item
                name="aadhar"
                label="Upload Aadhar Card"
                rules={[
                  { required: true, message: "Please upload Aadhar Card" },
                ]}
              >
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined />}>Upload Aadhar Card</Button>
                </Upload>
              </Form.Item>

              {/* PAN Card Upload */}
              <Form.Item
                name="pan"
                label="Upload PAN Card"
                rules={[{ required: true, message: "Please upload PAN Card" }]}
              >
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined />}>Upload PAN Card</Button>
                </Upload>
              </Form.Item>

              {/* License Upload */}
              <Form.Item
                name="license"
                label="Upload Service License"
                rules={[
                  { required: true, message: "Please upload Service License" },
                ]}
              >
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined />}>
                    Upload Service License
                  </Button>
                </Upload>
              </Form.Item>
            </Panel>
          </Collapse>
        </Form.Item>
         {/* Bank Details Section */}
         <Collapse>
          <Panel header="Bank Details" key="bankDetails">
            <Form.Item
              name="accountHolderName"
              label="Bank Account Holder’s Name"
              rules={[{ required: true, message: "Account holder's name is required" }]}
            >
              <Input placeholder="Account Holder’s Name" />
            </Form.Item>

            <Form.Item
              name="bankName"
              label="Bank Name"
              rules={[{ required: true, message: "Bank name is required" }]}
            >
              <Input placeholder="Bank Name" />
            </Form.Item>

            <Form.Item
              name="branchName"
              label="Branch Name"
              rules={[{ required: true, message: "Branch name is required" }]}
            >
              <Input placeholder="Branch Name" />
            </Form.Item>

            <Form.Item
              name="ifscCode"
              label="IFSC Code"
              rules={[{ required: true, message: "IFSC Code is required" }]}
            >
              <Input placeholder="IFSC Code" />
            </Form.Item>

            <Form.Item
              name="accountNumber"
              label="Account Number"
              rules={[{ required: true, message: "Account Number is required" }]}
            >
              <Input placeholder="Account Number" />
            </Form.Item>

            <Form.Item
              name="gstNumber"
              label="GST Number (Optional)"
            >
              <Input placeholder="GST Number" />
            </Form.Item>
          </Panel>
        </Collapse>
        {/* Terms and Conditions Checkbox */}
        <Form.Item
          name="terms"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error("You must agree to the terms and conditions!")
                    ),
            },
          ]}
        >
          <Checkbox>
            I agree to the{" "}
            <span onClick={showModal} style={{ color: "#1677FF" }}>
              Terms and Conditions
            </span>
          </Checkbox>
        </Form.Item>
        <Button type="primary" htmlType="submit">
          Sign Up
        </Button>
        <Modal
          title="Terms and Conditions"
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null} // No footer buttons
        >
          <h1>Terms and Conditions</h1>

          <p>
            Welcome to ABOMED, a comprehensive healthcare platform connecting
            users to medicine delivery, lab investigations, blood bank services,
            and diagnostic imaging centers. By registering as a vendor on our
            platform, you agree to the following terms and conditions. Failure
            to adhere to these terms may result in account suspension or
            termination.
          </p>

          <h2>1. Vendor Registration</h2>
          <ul>
            <li>
              1.1. You agree to provide accurate, complete, and up-to-date
              business information, including licenses, certifications, and
              other documents required by law.
            </li>
            <li>
              1.2. You are responsible for maintaining the confidentiality of
              your login credentials and for all activities that occur under
              your account.
            </li>
          </ul>

          <h2>2. Product Listings and Pricing</h2>
          <ul>
            <li>
              2.1. All products and services must be listed with clear, accurate
              descriptions, including applicable prices and taxes.
            </li>
            <li>
              2.2. You certify that you are legally authorized to sell the
              listed products or services.
            </li>
          </ul>

          <h2>3. Order Fulfillment</h2>
          <ul>
            <li>
              3.1. You agree to fulfill all confirmed orders as quickly as
              possible and communicate any delays or issues promptly to the
              customer.
            </li>
            <li>
              3.2. Non-fulfillment or repeated delays may result in penalties or
              account suspension.
            </li>
          </ul>

          <h2>4. Payments and Fees</h2>
          <ul>
            <li>
              4.1. The platform reserves the right to deduct applicable service
              fees or commissions before remitting payments to vendors.
            </li>
            <li>
              4.2. Payments will be processed according to the payment schedule
              outlined by ABOMED.
            </li>
          </ul>

          <h2>5. Returns, Refunds, and Cancellations</h2>
          <ul>
            <li>
              5.1. All refund or return requests must be handled in compliance
              with the platform’s standard return and refund policies.
            </li>
            <li>
              5.2. Vendors are responsible for any costs associated with returns
              or refunds if the product is found defective or not as described.
            </li>
          </ul>

          <h2>6. Prohibited Products and Services</h2>
          <ul>
            <li>
              6.1. Vendors are strictly prohibited from listing counterfeit,
              expired, or unapproved medical products and services.
            </li>
            <li>
              6.2. Any violation of this clause may result in immediate account
              suspension and legal action.
            </li>
          </ul>

          <h2>7. Data Privacy and Security</h2>
          <ul>
            <li>
              7.1. You agree not to share, misuse, or disclose customer data
              collected through the platform.
            </li>
            <li>
              7.2. Vendors must comply with all applicable data privacy laws
              when handling customer information.
            </li>
          </ul>

          <h2>8. Termination of Account</h2>
          <ul>
            <li>
              8.1. ABOMED reserves the right to terminate your account without
              prior notice if you breach any of these terms.
            </li>
          </ul>

          <h2>9. Limitation of Liability</h2>
          <ul>
            <li>
              9.1. ABOMED will not be liable for any direct, indirect,
              incidental, or consequential damages arising from your use of the
              platform or any service interruptions.
            </li>
          </ul>

          <h2>10. Amendments to Terms</h2>
          <ul>
            <li>
              10.1. We may update or modify these terms at our discretion.
              Continued use of the platform after any changes constitutes
              acceptance of the revised terms.
            </li>
          </ul>

          <h2>11. Governing Law</h2>
          <ul>
            <li>
              11.1. These terms are governed by the laws of the Government of
              India.
            </li>
          </ul>

          <h2>12. Indemnification</h2>
          <ul>
            <li>
              12.1. You agree to indemnify and hold ABOMED, its affiliates, and
              partners harmless from any claims, damages, or expenses arising
              from your listings, transactions, or breach of these terms.
            </li>
          </ul>

          <h2>13. Commission Structure and Vendor Fees</h2>
          <p>
            We charge a percentage-based commission on payments received through
            our platform from vendors for services rendered. The commission
            rates are as follows:
          </p>
          <ul>
            <li>Lab Investigations: 15% of the total payment</li>
            <li>Diagnostic Centers: 15% of the total payment</li>
            <li>Blood Banks: 10% of the total payment</li>
            <li>Medicine Delivery: 5% of the total payment</li>
          </ul>
          <p>
            By using our platform, vendors agree to this fee structure, which
            may be updated periodically at our discretion with prior notice.
          </p>

          <p>
            By using ABOMED’s platform, you agree to comply with these terms and
            conditions. We are committed to fostering a trustworthy and secure
            environment for healthcare services.
          </p>
        </Modal>
        <p>
          Already have an account?{" "}
          <Button type="link" onClick={switchToLogin}>
            Login
          </Button>
        </p>
      </Form>
    </div>
  );
};

export default SignupForm;
